import { render, staticRenderFns } from "./DiskOptionsUpdate.vue?vue&type=template&id=97f8d058&"
import script from "./DiskOptionsUpdate.vue?vue&type=script&lang=js&"
export * from "./DiskOptionsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./DiskOptionsUpdate.vue?vue&type=style&index=0&id=97f8d058&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports